<template>
  <div class="card card-plain">
    <div v-if="store.state.alert.message" class="card-header py-0">
      <argon-alert 
        v-show="store.state.alert.type == 'danger'"
        class="mb-0 text-sm text-center" 
        :color="store.state.alert.type"
      >
        {{ store.state.alert.message }}
      </argon-alert>
    </div>
    <div class="card-body">
      <form @submit.prevent="addVoucher">
        <div class="mb-3">
          <input
            class="form-control form-control-lg"
            type="text"
            ref="autofocus"
            v-model="voucher"
            placeholder="Kód voucheru"
            name="voucherCode"
            autocomplete="off" 
          />
          <span v-if="v$.voucher.$error" class="text-danger text-sm">
            {{ v$.voucher.$errors[0].$message }}
          </span>
        </div>
        <argon-button
          class="mt-4"
          type="submit" 
          color="primary"
          size="lg"
          :disabled="isButtonLoading"
          full-width>
          <span v-if="isButtonLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Uplatnit voucher
        </argon-button>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, inject, onMounted, nextTick } from 'vue';
import { useStore } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { required, helpers, minLength, maxLength } from '@vuelidate/validators';
import dataService from '@/services/dataService';
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

const store = useStore();
const swal = inject('$swal');

const isButtonLoading = computed(() => store.getters['loadingModule/isButtonLoading']);
const autofocus = ref(null);

const voucher = ref('');

// set rules
const rules = computed(() => {
  return {
    voucher: { 
      required: helpers.withMessage('Zadej kód voucheru', required), 
      maxLength: helpers.withMessage('Kód může obsahovat maximálně 20 znaků', maxLength(25)),
    }
  }
})
// init vuelidate
const v$ = useVuelidate(rules, { voucher });

const addVoucher = async () => {
  const isFormCorrect = await v$.value.$validate();

  if (!isFormCorrect) return;
  
  try {
    const response = await dataService.addVoucher(
      store.state.user.UserID,
      store.getters.isLoggedIn,
      voucher.value
    );

    if (response.Result) {
      store.dispatch('closeModal');
      swal.fire({
        position: 'center',
        icon: 'success',
        html: `<h5>${response.InfoMessage[0]}</h5>`,
        showConfirmButton: false,
        timer: 3000,
      });
    } else {
      store.dispatch('alertError', response.ErrorMessage.map(message => message).join(''));
      v$.value.$reset();
    }
  } catch (error) {
    console.error("An error occurred while submitting the voucher:", error);
  }
};

onMounted(() => {
  nextTick(() => {
    autofocus.value.focus();
  })
});

</script>